const NAMESPACE = 'design-system-stenciljs';
const Env = /* design-system-stenciljs */ {"appVersion":"8.0.1"};

export { Env as E, NAMESPACE as N };
